import { LoginRegistrationModal } from "./LoginRegistrationModal";

export default LoginRegistrationModal;
